import React from "react";

import homeSchema from "../src/recourses/schemaOrg/homeSchema";
import { type PropsWithChildren } from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import BaseSEO from "./BaseSEO";

type BaseSEOProps = PropsWithChildren<{
  url: string;
  context?: object;
}>;

const HomeSEO = ({ children, url, context = {} }: BaseSEOProps) => {
  return (
    <HelmetProvider context={context}>
      <BaseSEO url={url}>
        {children}
        <Helmet prioritizeSeoTags>
          <script type="application/ld+json">{JSON.stringify(homeSchema)}</script>
        </Helmet>
      </BaseSEO>
    </HelmetProvider>
  );
};

export default HomeSEO;
